import "./EmbedIFrame.css";

const EmbedIFrame = () => {
  return (
    <div className="embed-iframe-docs">
      <h1 className="embed-iframe-title">Embedding via IFrame</h1>

      <p className="embed-iframe-intro">
        You can integrate your chatbot into your website using an IFrame. Follow the steps below to obtain the IFrame code and deploy it.
      </p>

      <h2 className="embed-iframe-step">Step 1: Select Your Bot</h2>
      <p className="embed-iframe-intro">
        Navigate to <strong>Your Bots</strong> in the Xenachat dashboard and select the chatbot you wish to integrate.
      </p>

      <h2 className="embed-iframe-step">Step 2: Access Connect Settings</h2>
      <p className="embed-iframe-intro">
        Click on the <strong>Connect</strong> button on the left sidebar. Then, on the top bar, select the <strong>IFrame</strong> option to view the IFrame snippet.
      </p>

      <h2 className="embed-iframe-step">Step 3: Copy the IFrame Code</h2>
      <p className="embed-iframe-intro">
        Click the <strong>Copy</strong> button on the right side to copy the IFrame code. You can then embed this code into your website.
      </p>

      <pre className="embed-iframe-code">
{`<iframe
  src="https://api.xenachat.com/your-bot"
  width="400"
  height="600"
  style="border: none;"
></iframe>`}
      </pre>

      <h2 className="embed-iframe-step">Step 4: Use this IFrame Code</h2>
      <p className="embed-iframe-intro">
        You can then <strong>embed</strong> this code into your website.
      </p>
    </div>
  );
};

export default EmbedIFrame;
